export default function LearningToggleSwitch({ active }: { active: boolean }) {
  return (
    <div
      aria-hidden="true"
      style={{
        width: 28, height: 16, borderRadius: 8, flexShrink: 0,
        background: active ? 'var(--accent)' : 'var(--border)',
        position: 'relative', transition: 'background 0.2s',
      }}
    >
      <div style={{
        width: 12, height: 12, borderRadius: '50%', background: 'white',
        position: 'absolute', top: 2,
        left: active ? 14 : 2,
        transition: 'left 0.2s',
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
      }} />
    </div>
  )
}
